// Spinner.js
import './Spinner.css';

function Spinner() {
  return (
    <div className="spinner-container">
      <div className="loader"></div>
    </div>
  );
}
export default Spinner;
